<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import FileUpload from '@/components/FileUpload';

export default {
  name: 'ModuleTagsEdition',
  components: {
    FileUpload,
  },
  computed: {
    ...mapState('tag/item', [
      'item',
    ]),
    logo: {
      get () {
        return this.item.logo;
      },
      set (value) {
        const { item } = this;
        item.logo = value;
        this.setItem(item);
      },
    },
    name: {
      get () {
        return this.item.name;
      },
      set (value) {
        const { item } = this;
        item.name = value;
        this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('tag/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('tag/item', [
      'setItem',
      'reset',
    ]),
    localSave () {
      const payload = {
        name: this.item.name,
      };

      if (this.item.id) {
        payload.id = this.item.id;
      }

      this.save(payload)
        .then(() => {
          // if (!payload.id) {
          //   return;
          // }

          this.$router.push({ name: 'tags-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;

    if (!id) {
      this.reset();
      return;
    }

    this.fetch(id);
  },
};
</script>
<template>
  <div class="box">
    <h2>Tag Creator</h2>
    <!-- <FileUpload className="form-group pb-3" directory="company" v-model="logo" /> -->
    <div class="form-group mt-3">
      <label for="name" class="d-block">Name</label>
      <input id="name" class="form-control rounded-0" v-model="name" />
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
